var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"locationList"},_vm._l((_vm.locationItems),function(location){return _c('ListItemLocation',{key:location.place_id,attrs:{"title":location.title,"text":location.text},on:{"click":function($event){return _vm.selectLocation(location.place_id)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }